<template>
  <div>
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />

    <b-form>
      <b-form-group label-for="name">
        <template slot="label">
          Nom <span class="text-danger">*</span>
        </template>
        <b-form-input id="name" name="name" placeholder="Nom du nouveau label" v-model="name" data-vv-as="Nom" v-validate="'required'"></b-form-input>
        <div v-show="errors.has('name')" class="alert alert-danger mt-3">{{ errors.first('name') }}</div>
      </b-form-group>
      <b-form-group label-for="Schools">
        <template slot="label">
          Ecole <span class="text-danger">*</span>
        </template>
        <b-form-select id="Schools" name="Schools" v-model="schoolId" :options="schools_list" data-vv-as="Ecole" v-validate="'required'" @change="getTypes"></b-form-select>
        <div v-show="errors.has('Schools')" class="alert alert-danger mt-3">{{ errors.first('Schools') }}</div>
      </b-form-group>
      <b-form-group label-for="Types">
        <template slot="label">
          Type <span class="text-danger">*</span>
        </template>
        <b-form-select id="Types" name="Types" v-model="typeId" :options="types" data-vv-as="Type" v-validate="'required'"></b-form-select>
        <div v-show="errors.has('Types')" class="alert alert-danger mt-3">{{ errors.first('Types') }}</div>
      </b-form-group>
      <b-btn type="submit" variant="primary" @click.prevent="edit">{{ button }}</b-btn>
      <router-link to="/labels/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data () {
    return {
      button: '',
      h1: '',
      name: '',
      schoolId: '',
      schools_list: [{ value: '', text: '--- Sélectionnez une école ---' }],
      typeId: '',
      types: [{ value: '', text: '--- Sélectionnez un type ---' }]
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'schools', 'userId']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    edit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.id) {
            this.$http.post(this.domain + '/api/labels?access_token=' + this.access_token, { name: this.name, schoolId: this.schoolId, typeId: this.typeId, ionisId: this.userId }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('Le label a bien été ajouté', {
                    title: 'Label ajouté',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/labels/list')
                }
              })
            }, (response) => {

            })
          } else {
            this.$http.post(this.domain + '/api/labels/' + this.id + '/replace?access_token=' + this.access_token, { name: this.name }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('Le label a bien été modifié', {
                    title: 'Label modifié',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/labels/list')
                }
              })
            }, (response) => {

            })
          }
        }
      })
    },
    getTypes () {
      this.types = [{ value: '', text: '--- Sélectionnez un type ---' }]
      this.$http.get(this.domain + '/api/types?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            let type = data[i].schools.find(a => a.id === this.schoolId)
            console.log(type)
            if (type !== undefined) {
              this.types.push({
                value: data[i].id,
                text: data[i].name
              })
            }
          }
        })
      }, (response) => {

      })
    }
  },
  mounted () {
    document.getElementById('name').focus()
    if (this.id) {
      this.$http.get(this.domain + '/api/labels/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.name = data.name
          this.schoolId = data.schoolId
          this.getTypes()
          this.typeId = data.typeId
        })
      }, (response) => {

      })
      this.button = 'Editer'
      this.h1 = 'Editer un label'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter un label'
    }
    // this.$http.get(this.domain + '/api/types?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
    //   response.json().then((data) => {
    //     for (let i = 0; i < data.length; i++) {
    //       this.types.push(
    //         {
    //           value: data[i].id,
    //           text: data[i].name
    //         }
    //       )
    //     }
    //   })
    // }, (response) => {

    // })
    for (let i = 0; i < this.schools.length; i++) {
      this.schools_list.push(
        {
          value: this.schools[i].id,
          text: this.schools[i].name
        }
      )
    }
    // this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
    //   response.json().then((data) => {
    //     for (let i = 0; i < data.length; i++) {
    //       if (this.schools.includes(data[i].id)) {
    //         this.schools_filter.push(data[i])
    //       }
    //     }
    //   })
    // }, (response) => {

    // })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Labels/Edit.vue